module.exports = __webpack_public_path__ + "static/img/ai-qr.57adf65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcimages/ai-qr.png
// module id = O6Op
// module chunks = 51